import { useEffect, useState } from "react";

import { getTranslation } from "../../services/api";

export const useMessageTranslation = message => {
  const [translation, setTranslation] = useState(null);
  const [showTranslation, setShowTranslation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const toggleTranslation = () => setShowTranslation(previous => !previous);

  useEffect(() => {
    if (translation || isLoading || !message || !showTranslation) return;

    const fetchTranslation = async () => {
      setIsLoading(true);

      try {
        const {
          data: { message: newTranslation }
        } = await getTranslation(message);

        if (newTranslation) {
          setTranslation(newTranslation);
        } else {
          setError(new Error("No translation"));
          setShowTranslation(false);
        }
      } catch (error) {
        setError(error);
        setShowTranslation(false);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTranslation();
  }, [message, showTranslation, translation, isLoading]);

  return {
    translation: showTranslation ? translation : null,
    isTranslationLoading: isLoading,
    isTranslationError: !!error,
    toggleTranslation
  };
};
